import { Component, ChangeDetectionStrategy } from '@angular/core';
import { DxScrollViewComponent } from 'devextreme-angular/ui/scroll-view';

@Component({
    selector: 'app-single-card',
    templateUrl: './single-card.component.html',
    styleUrls: ['./single-card.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [DxScrollViewComponent],
})
export class SingleCardComponent {
    constructor() {}
}
